// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1mCsb","filesListContainer":"PosDisputesFiles_filesListContainer__2_T6-","filesButton":"PosDisputesFiles_filesButton__DARvg"};